import React, { Component } from 'react';
import { can } from '../permissions/access';
import { PERMISSIONS_VISIBLE } from '../../config/featureFlags';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import TopHeader from '../template/TopHeader';
import MobileSubmenu from '../shared/MobileSubmenu';

class StaffMobileNav extends Component {
    constructor(props) {
        super(props);
    }

    get isSelfEmployed() {
        const hd = this.props.user?.userInfo?.hairdresser;
        // A self-employed stylist whose role manages the team gets the team menu.
        return hd?.employmentTypeId === 2 && hd?.isSalonOwner !== 1 && !can('team');
    }

    handleNavClick = (url) => {
        this.props.history.push(url);
    };

    receptionHidden(key) {
        try {
            const r = JSON.parse(localStorage.getItem('receptionModeSettings') || '{}');
            return !!(r.enabled && r.hiddenAreas && r.hiddenAreas[key]);
        } catch (e) {
            return false;
        }
    }

    render() {
        const isSE = this.isSelfEmployed;
        const staffNav = (isSE ? [
            {
                id: 'my-profile',
                url: '/staff',
                title: 'My Profile',
                description: 'View and edit your profile',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /></svg>
            },
            {
                id: 'my-rota',
                url: '/staff/schedules',
                title: 'My Rota',
                description: 'Manage your working hours',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
            }
        ] : [
            {
                id: 'team-members',
                url: '/staff',
                title: 'Team Members',
                description: 'View and manage all team members',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
            },
            {
                id: 'schedules',
                url: '/staff/schedules',
                title: 'Schedules & Hours',
                description: 'Manage team schedules and working hours',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
            },
            {
                id: 'staff-pay',
                url: '/staff/staff-pay',
                title: 'Staff Pay',
                description: 'Calculate pay from hours worked',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>
            },
            {
                id: 'permissions',
                url: '/staff/permissions',
                title: 'Permissions',
                description: 'Roles and what each can do',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" /></svg>
            }
        ]).filter(item => {
            if (isSE) return true;
            // Roles & permissions (mirrors Staff.teamTabs): Staff Pay needs
            // team; Permissions needs team or permissions, never in Reception Mode.
            const isOwner = this.props.user?.userInfo?.hairdresser?.isSalonOwner === 1;
            if (item.id === 'staff-pay' && !(isOwner || can('team'))) return false;
            if (item.id === 'permissions') {
                let receptionOn = false;
                try { receptionOn = !!JSON.parse(localStorage.getItem('receptionModeSettings') || '{}').enabled; } catch (e) { /* ignore */ }
                if (!PERMISSIONS_VISIBLE || receptionOn || !(can('team') || can('permissions'))) return false;
            }
            const key = { 'team-members': 'teamMembers', 'schedules': 'schedules', 'staff-pay': 'staffPay' }[item.id];
            return !(key && this.receptionHidden(key));
        });

        return (
            <div className="h_n">
                <div className="body_container cm_bg_white">
                    <TopHeader title={isSE ? 'Profile' : 'Team'} headerButtonStatus={true} {...this.props} />
                    <MobileSubmenu items={staffNav} onNavigate={this.handleNavClick} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { ...state };
}

export default withRouter(connect(mapStateToProps)(StaffMobileNav));
